import type { InferContractRouterOutputs } from '@orpc/contract'
import { useQuery } from '@tanstack/react-query'
import type { BaseContract } from 'pixai-contract/api/orpc'
import { orpc } from './contract'

export type SizeConfigResponse =
  InferContractRouterOutputs<BaseContract>['generationModel']['getSizeConfig']
export type SizeRange = SizeConfigResponse['ranges'][number]
export type SizePreset = SizeRange['presets'][number]

export function useGenerationModelGetSizeConfig(modelVersionId?: string) {
  return useQuery({
    ...orpc.generationModel.getSizeConfig.queryOptions({
      // Fallback to '' (instead of non-null-assertion) so `queryOptions` always
      // receives a defined value. Pairs with `enabled: !!modelVersionId` so the
      // request never actually fires on the empty-string key.
      input: { modelVersionId: modelVersionId ?? '' },
    }),
    enabled: !!modelVersionId,
    staleTime: 5 * 60 * 1000,
    // The handler computes per-tier `accessStatus` from `ctx.user`'s
    // membership tier (see `serializeSizeConfigResponse(ranges, userTier)`).
    // Without this meta, React Query would keep the anonymous (tier=0) result
    // visible after login or a previous user's gated ranges after logout.
    meta: { dependsOn: ['login'] },
  })
}
